import { format, isValid } from 'date-fns';

const tryFormat = (date: string, dateFormat: string) => {
  if (isValid(new Date(date))) return format(new Date(date), dateFormat);
  return date;
};

export const literalMonthDateFormat = (date: string) => tryFormat(date, 'MMMM d, yyyy');
export const shortcutLiteralMonthDateFormat = (date: string) => tryFormat(date, 'MMM dd, yyyy');
export const webinarDateFormat = (date: string) => tryFormat(date, 'EEEE, LLLL d');
